import { render, staticRenderFns } from "./DeleteStudent.vue?vue&type=template&id=871fa77a&"
import script from "./DeleteStudent.vue?vue&type=script&lang=js&"
export * from "./DeleteStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports